<template>

  <div class="user">
    <!--添加类别-->
    <div class="common-level-rail">
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus">添加类别</el-button>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="name" label="类别名称" width="300"></el-table-column>
          <el-table-column label="入住费">
            <template slot-scope="scope">
            <span>{{scope.row.setting.charge_fee}}</span>
          </template>	
          </el-table-column>
         <el-table-column  label="赠送短信">
            <template slot-scope="scope">
            <span>{{scope.row.setting.senddx}}</span>
          </template>	
          </el-table-column>
          <!-- <el-table-column  label="保证金">
            <template slot-scope="scope">
            <span>{{scope.row.setting.deposit}}</span>
          </template>	
          </el-table-column> -->
           <!-- <el-table-column  label="权限">
            <template slot-scope="scope">
            <el-tag size="mini" disable-transitions v-if="scope.row.setting.order_detail=='1'">订单详情</el-tag>
            <el-tag size="mini" disable-transitions v-if="scope.row.setting.order_send=='1'">订单发货</el-tag>
            <el-tag size="mini" disable-transitions v-if="scope.row.setting.order_aftersale=='1'">订单售后</el-tag>
            <el-tag size="mini" disable-transitions v-if="scope.row.setting.product_add_check=='1'">添加需要审核</el-tag>
            <el-tag size="mini" disable-transitions v-if="scope.row.setting.product_edit_check=='1'">修改需要审核</el-tag>
            <el-tag size="mini" disable-transitions v-if="scope.row.setting.product_price_edit=='1'">价格修改</el-tag>
            <el-tag size="mini" disable-transitions v-if="scope.row.setting.product_discount_edit=='1'">会员类别价格修改</el-tag>
            <el-tag size="mini" disable-transitions v-if="scope.row.setting.product_shelf_edit=='1'">上架后可修改</el-tag>
            <el-tag size="mini" disable-transitions v-if="scope.row.setting.product_product_op=='1'">产品操作</el-tag>
            
          
          </template>	
          </el-table-column>
           -->
          <el-table-column prop="remark" label="备注">
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="text" size="small" >编辑</el-button>
              <el-button @click="deleteClick(scope.row)" type="text" size="small" >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

    <!--添加-->
    <Add v-if="open_add" :open_add="open_add" @closeDialog="closeDialogFunc($event, 'add')"></Add>

    <!--编辑-->
    <Edit v-if="open_edit" :open_edit="open_edit" :form="userModel" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>
  </div>
</template>

<script>
  import SupplyApi from '@/api/supply.js';
  import Edit from './Edit.vue';
  import Add from './Add.vue';
  import {deepClone} from '@/utils/base.js';
  export default {
    components: {
      /*编辑组件*/
      Edit,
      Add
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          user: '',
          region: ''
        },
        /*是否打开添加弹窗*/
        open_add: false,
        /*是否打开编辑弹窗*/
        open_edit: false,
        /*当前编辑的对象*/
        userModel: {}
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();

    },
    methods: {

      /*换行*/
      keepTextStyle(val){
        let str=val.replace(/(\\r\\n)/g,'<br/>');
        return str;
      },

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = {};
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        SupplyApi.gradeLists(Params, true)
          .then(data => {
            console.log('this is data',data);
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total
          })
          .catch(error => {

          });
      },

      /*打开添加*/
      addClick() {
        this.open_add = true;
      },

      /*打开编辑*/
      editClick(item) {
        this.userModel = deepClone(item);
        this.open_edit = true;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        if (f == 'add') {
          this.open_add = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
        if (f == 'edit') {
          this.open_edit = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
      },

      /*删除用户*/
      deleteClick(row) {
        let self = this;
        self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.loading = true;
          SupplyApi.deletegrade({
              kmd_grade_id: row.kmd_grade_id
            }, true)
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: data.msg,
                  type: 'success'
                });
                self.getTableList();
              } else {
                self.$message.error('错了哦，这是一条错误消息');
              }
            })
            .catch(error => {
              self.loading = false;
            });

        }).catch(() => {

        });
      }

    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/supply/grade/index.vue